// auth/auth.token.ts
import { InjectionToken } from '@angular/core';
import { IAuthService } from './auth.types';

export const AUTH_SERVICE = new InjectionToken<IAuthService>('AUTH_SERVICE');
